import { CKBox, CKButton } from 'clearkit';

import { SelectCustomObject } from './SelectCustomObject';
import { SelectTargetAttribute } from './SelectTargetAttribute';
import {
  canSaveCustomObject,
  canSelectAttribute,
} from './useStateMachine/guards';
import { Send, State } from './useStateMachine/types';

type LinkingFormProps = {
  state: State;
  send: Send;
};
export function LinkingForm({ state, send }: LinkingFormProps) {
  if (!state.context.isShowingLinkForm) {
    return null;
  }

  return (
    <div className="pt-4 mt-4 border-t">
      <CKBox variant="card">
        <div className="px-5 py-4">
          <SelectCustomObject
            items={state.context.disabledObjects}
            label="Salesforce custom object"
            onChange={(object) => send('SELECT_OBJECT', { object })}
            value={state.context.selectedObject}
          />
          <SelectTargetAttribute
            className="mt-5"
            isDisabled={!canSelectAttribute(state.context)}
            items={state.context.targetAttributes}
            label="Email key"
            onChange={(attribute) =>
              send('SELECT_EMAIL_ATTRIBUTE', { attribute })
            }
            placeholder="Select email key"
            value={state.context.selectedEmailAttribute}
          />
          <p className="mt-1 text-xs text-gray-600">
            The email key is the field on the custom object that will be used
            for enrichment. It must be an email address and will be used to
            enrich person and company deatils.
          </p>
          <SelectTargetAttribute
            className="mt-5"
            isDisabled={!canSelectAttribute(state.context)}
            items={state.context.targetAttributes}
            label="Domain key"
            onChange={(attribute) =>
              send('SELECT_DOMAIN_ATTRIBUTE', { attribute })
            }
            placeholder="Select domain key"
            value={state.context.selectedDomainAttribute}
          />
          <p className="mt-1 text-xs text-gray-600">
            The domain key is the field on the custom object that will be used
            for enrichment. It must be a domain and will be used to enrich
            company deatils.
          </p>
        </div>
        <div className="px-5 py-4 border-t border-gray-100">
          <CKButton
            isDisabled={!canSaveCustomObject(state.context)}
            isLoading={state.matches('saving')}
            onClick={() => send('SAVE')}
          >
            Link object
          </CKButton>
          <CKButton className="ml-2" onClick={() => send('STOP_LINKING')}>
            Cancel
          </CKButton>
        </div>
      </CKBox>
    </div>
  );
}
